import * as React from "react";
import { ListItem, ListItemIcon, ListItemText, createStyles } from "@material-ui/core";
import { NavItem } from "../../navItems";
import { withStyles, WithStyles } from "@material-ui/core/styles";

interface NavItemListItemButtonProps extends WithStyles<typeof styles> {
  navItem: NavItem;
  navigate: (path: string) => void;
}

class NavItemListItemButton extends React.PureComponent<NavItemListItemButtonProps> {
  navigate = () => {
    this.props.navigate(this.props.navItem.path);
  };

  render() {
    const { navItem, classes } = this.props;
    return (
      <ListItem classes={{ root: classes.listItemRoot }} button={true} onClick={this.navigate}>
        <ListItemIcon>
          <navItem.icon />
        </ListItemIcon>
        <ListItemText primary={navItem.title} />
      </ListItem>
    );
  }
}

const styles = () =>
  createStyles({
    listItemRoot: {
      borderRadius: 0,
      boxShadow: "none",
      marginTop: 0
    }
  });

export default withStyles(styles)(NavItemListItemButton);
